import { render, staticRenderFns } from "./assigned-project.vue?vue&type=template&id=32f4dbe4&"
import script from "./assigned-project.vue?vue&type=script&lang=js&"
export * from "./assigned-project.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports